module.exports = __webpack_public_path__ + "static/media/rs485_MC3.50b5db97.png";